__turbopack_context__.v({
  "activeDot": "QREK3q_activeDot",
  "cardImages": "QREK3q_cardImages",
  "cardImgWrapper": "QREK3q_cardImgWrapper",
  "counter": "QREK3q_counter",
  "dot": "QREK3q_dot",
  "dots": "QREK3q_dots",
});
